import { newApiFetch } from "./utils";

type ISearchInterestData = {
  data: Array<{ market: string }>;
};

export const getSearchInterestData = (): Promise<ISearchInterestData> => newApiFetch("/search_interest/brand_model/get", {});
